import {makeGetOdontoProviderAddress} from 'main/factories/usecases';
import {CheckDentalAddressParams} from './types';

export function useGetOdontoProviderAddress() {
	async function checkDentalAddress({
		professionalCode,
		specialtyCode,
		unitCode,
		dateAt,
	}: CheckDentalAddressParams) {
		const response = await makeGetOdontoProviderAddress().get({
			cdPrestadorFisico: Number(professionalCode),
			cdEspecialidade: Number(specialtyCode),
			cdPrestadorJuridico: Number(unitCode),
			dtConsulta: dateAt,
		});

		return response;
	}

	return {
		checkDentalAddress,
	};
}
